var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4003 8.50843C19.9006 8.52518 19.7388 8.93237 19.7388 9.50846V18.3084H2.20033V9.50846C2.20033 8.93237 2.12642 8.50843 1.55033 8.50843C1.05033 8.50843 0.916992 8.93237 0.916992 9.50846L1.00033 18.3084C1.00033 19.2686 1.24018 19.5918 2.20033 19.5918H19.7388C20.6989 19.5918 21.0837 19.2686 21.0837 18.3084V9.50846C21.0837 8.93237 20.9837 8.48889 20.4003 8.50843Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4449 0.591262C11.2008 0.347184 10.8051 0.347184 10.561 0.591262L6.81099 4.34127C6.56691 4.58534 6.56691 4.98107 6.81099 5.22515C7.05507 5.46923 7.45079 5.46923 7.69487 5.22515L10.4204 2.49638V14.8986C10.4204 15.2353 10.6934 15.5082 11.03 15.5082C11.3667 15.5082 11.6396 15.2353 11.6396 14.8986V2.54254L14.311 5.22515C14.5551 5.46923 14.9508 5.46923 15.1949 5.22515C15.439 4.98107 15.439 4.58534 15.1949 4.34127L11.4449 0.591262Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/icShare.897207ee084d3813da571d0e09b83346.svg";
export { ForwardRef as ReactComponent };